import { useQuery } from '@tanstack/react-query';
import { config } from '@shared/config';
import { FooterConfigSchema, DEFAULT_FOOTER_CONFIG } from '@fanini/shared-types';
import type { FooterConfig } from '@fanini/shared-types';

/**
 * Liefert die Footer-Konfiguration vom öffentlichen API-Endpunkt.
 * Bei Fehler oder ungültiger Antwort werden Default-Werte zurückgegeben.
 *
 * @returns TanStack Query-Ergebnis mit der Footer-Konfiguration.
 *
 * @example
 * ```tsx
 * const { data } = useFooterConfig();
 * const sections = data?.sections ?? DEFAULT_FOOTER_CONFIG.sections;
 * ```
 */
export function useFooterConfig() {
  return useQuery<FooterConfig>({
    queryKey: ['public', 'footer'],
    queryFn: async () => {
      const res = await fetch(`${config.apiUrl}/public/footer`);
      if (!res.ok) throw new Error('Footer-Konfiguration konnte nicht geladen werden');
      const json: unknown = await res.json();
      const parsed = FooterConfigSchema.safeParse(json);
      if (!parsed.success) return DEFAULT_FOOTER_CONFIG;
      return parsed.data;
    },
    staleTime: 10 * 60_000,
    placeholderData: DEFAULT_FOOTER_CONFIG,
  });
}
